import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useMoveConfirmStore } from "@/store/move-confirm-store";

const INTENT_COPY: Record<string, { title: string; lead: string; cta: string }> = {
  create: {
    title: "Atención: se moverán reservas existentes",
    lead: "Para crear esta reserva se reubicarán {n} reservas existentes:",
    cta: "Confirmar y crear",
  },
  edit: {
    title: "Atención: se moverán reservas existentes",
    lead: "Para guardar esta reserva se reubicarán {n} reservas existentes:",
    cta: "Confirmar y guardar",
  },
  seat: {
    title: "Atención: se moverán reservas existentes",
    lead: "Para sentar esta reserva se reubicarán {n} reservas existentes:",
    cta: "Confirmar y sentar",
  },
  explorer: {
    title: "Atención: se moverán reservas existentes",
    lead: "Para aplicar este plan se reubicarán {n} reservas existentes:",
    cta: "Confirmar y aplicar",
  },
};

/** Promise-based dialog that EVERY flow shipping a `requires_moves`
 *  chain must open before calling the backend. Shows the operator
 *  exactly which reservations would relocate and where, with explicit
 *  confirm/cancel. */
export function MoveConfirmDialog() {
  const pending = useMoveConfirmStore((s) => s.pending);
  const close = useMoveConfirmStore((s) => s.close);

  const ctx = pending?.context;
  const moves = ctx?.moves ?? [];
  const copy = INTENT_COPY[ctx?.intent ?? "create"] ?? INTENT_COPY.create;
  const lead = copy.lead.replace("{n}", String(moves.length));

  return (
    <AlertDialog
      open={pending !== null}
      onOpenChange={(open) => {
        if (!open) close(false);
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>⚠️ {copy.title}</AlertDialogTitle>
          <AlertDialogDescription>
            <span className="block">{lead}</span>
            <ul className="mt-2 flex flex-col gap-1 text-foreground">
              {moves.map((m) => (
                <li key={`${m.reservation_id}-${m.to_table_names.join("|")}`} className="text-sm">
                  <strong>{m.guest_name || "Otra reserva"}</strong>
                  {m.pax > 0 ? ` (${m.pax}p)` : ""}: {m.from_table_names.join(" + ") || "—"} →{" "}
                  {m.to_table_names.join(" + ") || "—"}
                </li>
              ))}
            </ul>
            <span className="mt-3 block text-xs text-muted-foreground">
              Los huéspedes mantienen su zona (cuando aplica) y su horario.
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => close(false)}>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={() => close(true)}>{copy.cta}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
